<div class="verification-page-container">
  <div class="verification-card">
    <h1 class="verification-heading">Верификация на имейл</h1>
    <h1 class="verification-text">
      Имейл беше изпратен на {{ userEmail }}
    </h1>
    <h1 class="verification-text">Моля въведете верификационния код отдолу.</h1>
    <h1 class="verification-text">
      Ако не сте получили такъв имейл, моля проверете вашата спам папка.
    </h1>

    <form (ngSubmit)="onVerify()" class="email-verification-form gap-4">
      @if(errorMessage){
      <span class="text-red-500 text-center">
        {{ errorMessage }}
      </span>
      }

      <otw-form-field
        label="Верификационен код"
        for="verificationCode"
        labelClassNames="!text-black"
      >
        <p-inputotp
          [(ngModel)]="verificationCode"
          [length]="6"
          id="verificationCode"
          name="verificationCode"
          required
        />
      </otw-form-field>

      <div class="flex flex-col gap-2 w-full">
        <p-button
          label="Потвърди"
          [loading]="loading"
          severity="primary"
          type="submit"
          rounded
          class="!w-full h-full"
          styleClass="!w-full h-full"
        />
      </div>
    </form>
    <p-button
      link
      label="Изпрати нов код"
      (onClick)="onResendVerificationCode()"
      severity="primary"
      class="!w-full h-full"
      styleClass="!w-full h-full"
    />
    <div class="flex justify-center">
      <a href="/" class="link underline">Върнете се на началната страница</a>
    </div>
  </div>
</div>
<p-dialog
  header="Информация"
  [(visible)]="resendResultVisible"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '400px' }"
>
  <ng-template pTemplate="header">
    <span class="text-center"
      [ngClass]="
        resendModalSeverity === 'danger' ? 'text-red-600' : 'text-green-600'
      "
    >
      {{ resendModalMessage }}
    </span>
  </ng-template>
  <div class="flex justify-center mt-4">
    <p-button
      label="Затвори"
      (onClick)="resendResultVisible = false"
      severity="secondary"
    ></p-button>
  </div>
</p-dialog>
